import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import { selectClasses } from './selectClasses';

export const SelectRoot = styled('div', {
  name: 'AFSelect'
})('');

export const LabelContainer = styled(Grid, {
  shouldForwardProp: prop => prop !== 'hasAppIcon'
})(({ hasAppIcon }) => ({
  flex: 1,
  display: 'flex',
  overflow: 'hidden',
  alignItems: hasAppIcon ? 'center' : null,
  [`& .${selectClasses.selectButtonText}`]: {
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    textAlign: 'left'
  }
}));

export const IconContainer = styled('span')(({ theme }) => ({
  marginRight: theme.spacing(1)
}));
